import React, { useEffect, useState } from 'react';

import dayjs from 'dayjs';
import { Row, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { Button } from '../../../components';
import { generateReport, getReportData, removeReportData, getList } from '../operations';
import { customStyles } from '../utils';

import './styles.scoped.css';

const SAClientRankingAMCForm = ({ setForm, form, setLoadingResults, setData, setShowResults }) => {
  const navigate = useNavigate();
  const [branches, setBranches] = useState([]);
  const [isLoadingBranches, setIsLoadingBranches] = useState(false);
  const [lob, setLob] = useState([]);
  const [isLoadingLOB, setIsLoadingLOB] = useState(false);

  useEffect(() => {
    handleGetBranches();
    handleGetLOB();
  }, []);

  const handleGetBranches = async () => {
    setIsLoadingBranches(true);
    const newBranches = await getList('clients/branches');
    setBranches(
      newBranches.map(({ Branch_Code, Branch_Name }) => ({
        label: `${Branch_Name} - ${Branch_Code}`,
        value: Branch_Code,
      })),
    );
    setIsLoadingBranches(false);
  };

  const handleGetLOB = async () => {
    setIsLoadingLOB(true);
    const newLob = await getList('line-of-business');
    setLob(
      newLob.map(({ LineOfBusinessCode, LineOfBusinessDesc }) => ({
        label: LineOfBusinessDesc,
        value: LineOfBusinessCode,
      })),
    );
    setIsLoadingLOB(false);
  };
  const handleViewResults = async () => {
    if (
      !(
        dayjs(form?.ToPerEnddate).isAfter(form?.FromPerEnddate) ||
        dayjs(form?.FromPerEnddate).isSame(form?.ToPerEnddate)
      )
    ) {
      // eslint-disable-next-line no-undef
      alert('Invalid date range. Please double check and try again.');
      return;
    }
    setLoadingResults(true);
    const { FromPerEnddate, ToPerEnddate, Branch, LineOfBusiness } = form;
    try {
      const response = await generateReport({
        endpoint: 'client-ranking-report-amc',
        payload: {
          FromPerEnddate,
          ToPerEnddate,
          Branch,
          LineOfBusiness,
        },
      });

      if (response.location && response.location !== '') {
        const reportData = await getReportData(response.location);
        if (reportData?.length) {
          await removeReportData(response.location);
          setLoadingResults(false);
          setData(reportData);
          setShowResults(true);
        }
      } else {
        setLoadingResults(false);
        setLoadingResults(false);
        // eslint-disable-next-line no-undef
        alert('No data found matching your criteria.');
      }
    } catch (error) {
      console.log(error);
      setLoadingResults(false);
    }
  };

  const handleChange = e => {
    const _form = { ...form, [e.target.name]: e.target.value };
    setForm(_form);
  };
  return (
    <Form
      noValidate
      onSubmit={() => {}}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <div className="filters-row">
        <div
          className="filter-row"
          style={{
            marginTop: '30px',
          }}>
          <Form.Group as={Row} controlId="FromPerEnddate" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>
              <div className="required">Period End Date </div>
            </Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              type="date"
              name="FromPerEnddate"
              defaultValue={form?.FromPerEnddate}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group as={Row} controlId="ToPerEnddate" style={{ alignItems: 'center' }}>
            <Form.Label
              style={{
                width: '20px',
                marginLeft: '30px',
                marginRight: '20px',
              }}>
              To
            </Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
              }}
              as="input"
              type="date"
              name="ToPerEnddate"
              defaultValue={form?.ToPerEnddate}
              onChange={handleChange}
            />
            <Form.Control.Feedback type="invalid" />
          </Form.Group>
        </div>
        <div className="filter-row">
          <Form.Group as={Row} style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Branch Number</Form.Label>
            <div className="dropdown-spinner-container">
              <Select
                isMulti
                closeMenuOnSelect={false}
                styles={customStyles('360px')}
                isDisabled={isLoadingBranches}
                options={branches}
                isClearable
                value={form?.Branch?.split(',').map(code => branches.find(option => String(option.value) === code))}
                onChange={selectedOptions => {
                  const selectedCodes = selectedOptions.map(option => option.value);
                  setForm({
                    ...form,
                    Branch: selectedCodes.join(','),
                  });
                }}
              />
              {isLoadingBranches && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  aria-hidden="true"
                  className="dropdown-spinner"
                />
              )}
            </div>
          </Form.Group>
        </div>
        <div className="filter-row">
          <Form.Group as={Row} style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Line Of Business</Form.Label>
            <div className="dropdown-spinner-container">
              <Select
                isMulti
                closeMenuOnSelect={false}
                styles={customStyles('360px')}
                isDisabled={isLoadingLOB}
                options={lob}
                isClearable
                onChange={selectedOptions => {
                  const selectedCodes = selectedOptions.map(option => option.value);
                  setForm({
                    ...form,
                    LineOfBusiness: selectedCodes.join(','),
                  });
                }}
                value={form?.LineOfBusiness?.split(',').map(code => lob.find(option => option.value === code))}
              />
              {isLoadingLOB && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  aria-hidden="true"
                  className="dropdown-spinner"
                />
              )}
            </div>
          </Form.Group>
        </div>
      </div>
      <div className="buttons-row">
        <Button
          variant="primary"
          disabled={!form?.ToPerEnddate || !form?.FromPerEnddate}
          onClick={handleViewResults}
          style={{ marginRight: '20px', width: '100px' }}
          text="View"
        />

        <Button
          style={{ width: '100px' }}
          onClick={() => navigate('/edge-reporting')}
          variant="outline"
          text="Cancel"
        />
      </div>
    </Form>
  );
};

export default SAClientRankingAMCForm;
